import LoadingSpinner from '@/components/ui/loading-spinner';
import DetailFieldsCard, { DetailField } from '@/components/DetailFieldsCard';
import { useSite } from '@/hooks/sites/useSite';
import { getEntityStatusInfo } from '@/utils/entityStatuses';
import { formatTimestamp } from '@/utils/dates';

const SiteDetailsContent = ({ siteId }: { siteId: string }) => {
  const { data: site, isLoading } = useSite(siteId);
  const statusInfo = site?.status ? getEntityStatusInfo(site.status) : null;

  if (isLoading) return <LoadingSpinner />;

  const fields: DetailField[] = [
    { label: 'Site ID', value: site?.display_id },
    {
      label: 'Status',
      render: statusInfo ? (
        <div className="inline-flex items-center gap-2">
          <div
            className="w-2 h-2 rounded-full"
            style={{ backgroundColor: statusInfo.color }}
          />
          <span className="text-gray-900">{statusInfo.label}</span>
        </div>
      ) : undefined,
    },
    { label: 'Site Name', value: site?.site_name },
    { label: 'PI Name', value: site?.pi_name },
    {
      label: 'Countries',
      value:
        site?.countries && site.countries.length
          ? site.countries.join(', ')
          : null,
    },
    { label: 'Parent Study', value: site?.study?.protocol_number ?? null },
    { label: 'Category', value: site?.submission_template?.category },
    { label: 'Sub-Category', value: site?.submission_template?.sub_category },
    { label: 'Variant', value: site?.submission_template?.variant },
    { label: 'Activated', value: formatTimestamp(site?.submitted_at) },
    { label: 'Expiration', value: formatTimestamp(site?.expiration_date) },
    { label: 'Created', value: formatTimestamp(site?.created_at) },
  ];

  return (
    <div className="space-y-6">
      <DetailFieldsCard title="Site Details" fields={fields} />
    </div>
  );
};

export default SiteDetailsContent;
